import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Enterprise from './pages/EnterpriseLogin';
import UserLogin from './pages/UserLogin';
import Splash from './pages/SplashScreen';
import AreaAllocation from './pages/AreaAllocation';
import UnitAssign from './pages/UnitAssign';
import FetchSteps from './pages/FetchSteps';
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import Logout from './pages/Logout'
import DashBoard from './pages/DashBoard';
import MyAccount from './pages/MyAccount';
import AboutUs from './pages/AboutUs';
import Privacy from './pages/Privacy';
import ChangePassword from './pages/ChangePassword';
import ForGotPassword from './pages/ForGotPassword';
import Checklist from './pages/Checklist';
import Observation from './pages/Observation';
import Suggestion from './pages/Suggestion';
import QRScanner from './pages/QRScanner';
import Groups from './pages/Groups';
import Group from './pages/Group';
import Insight from './pages/Insight';
import OverView from './pages/Overview';
import SearchUnit from './pages/SearchUnit';
import Notification from './pages/Notification';
import VideoExample from './pages/VideoExample';
import Chat from './pages/Chat';
import Spaces from './pages/Spaces';
// import {initializeFirebase,askForPermissionToReceiveNotification,data} from './pages/PushNotification'
import Test from './pages/Test';
import Resume from './pages/Resume';
import Star from './pages/Star';
import PauseSession from './pages/PauseSession';
import Classroom from './pages/Classroom';
import Certificate from './pages/Certificate';
import TestErrorHandling from './pages/TestErrorHandling';
import { setupAxiosInterceptors, setGlobalErrorHandler } from './utils/axiosInterceptors';
import { ErrorModal } from './component/ErrorModal';
class App extends Component {

  constructor(props) {
        super(props);
        this.state = {
            value: '',
            showErrorModal: false,
            errorMessage: ''
        };
        //  initializeFirebase();

    }
    componentWillMount(){

        // if(!localStorage.getItem('notification-token')){
        //     askForPermissionToReceiveNotification();
        // }

        // Setup axios interceptors for global error handling
        setupAxiosInterceptors();

        // Set global error handler to show modal
        setGlobalErrorHandler((errorMessage) => {
            this.setState({
                showErrorModal: true,
                errorMessage: errorMessage
            });
        });

    }

    handleCloseErrorModal = () => {
        this.setState({
            showErrorModal: false,
            errorMessage: ''
        });
    }
     

    render() {

        return (
            <BrowserRouter>
                <div className="App">
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Switch>
                        {/* <Route path="/" exact component={Enterprise} /> */}
                        <Route path="/" exact render={routeProps => <UserLogin  {...routeProps} />}/>
                        <Route path="/splash" component={Splash} />
                        <Route path="/area" component={AreaAllocation} />
                        <Route path="/unit" component={UnitAssign} />
                        <Route path="/units/:id" component={FetchSteps} />
                        <Route path="/logout" component={Logout} />
                        <Route path="/dashboard" component={DashBoard} />
                        <Route path="/myaccount" component={MyAccount} />
                        <Route path="/about" component={AboutUs} />
                        <Route path="/privacy" component={Privacy} />
                        <Route path="/changepassword" component={ChangePassword} />
                        <Route path="/forgotpassword" component={ForGotPassword} />
                        <Route path="/checklist" component={Checklist} />
                        <Route path="/certificate" component={Certificate} />
                        <Route path="/observation" component={Observation} />
                        <Route path="/suggestion" component={Suggestion} />
                        <Route path="/qrscan" component={QRScanner} />
                        <Route path="/groups" component={Groups} />
                        <Route path="/group/:id" render={routeProps => <Group  {...routeProps} />} />
                        <Route path="/insight" component={Insight} />
                        <Route path="/overview" component={OverView} />
                        <Route path="/search" component={SearchUnit} />
                        <Route path="/video/:id"  component={VideoExample}/>
                        <Route path="/notification" component={Notification} />
                        <Route path="/resume" component={Resume} />
                        <Route path="/pause/:id" component={PauseSession} />
                        <Route path="/spaces" component={Spaces}/>
                        <Route path="/star" component={Star}/>
                        <Route path="/chat/:id" render={routeProps => <Chat  {...routeProps} />} />
                        <Route path="/test" component={Test}/>
                        
                        <Route path="/test-error" component={TestErrorHandling}/>

                        <Route path="/classroom" component={Classroom}/>
                    </Switch>
                    </MuiPickersUtilsProvider>

                    {/* Global Error Modal */}
                    <ErrorModal
                        showModal={this.state.showErrorModal}
                        handleClose={this.handleCloseErrorModal}
                        errorMessage={this.state.errorMessage}
                        title="Server Connection Error"
                    />
                </div>
            </BrowserRouter>
        );
    }
}

export default App;